import React, { Component } from 'react';
import { TextField } from '@material-ui/core';
import { validateEmail, WrongEmailFormatText } from '../Common';

type Props = {
    email: string,
    onChange: (email: string) => void,
    onFormatErrorChange?: (isError: boolean) => void,
    variant?: any,
    disabled?: boolean
}

type State = {
    emailFormatError: boolean,
}

class EmailInput extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            emailFormatError: false

        }
    }

    render() {
        return (
            <TextField
                label="E-mail address"
                type="email"
                name="email"
                autoComplete="email"
                margin="normal"
                variant={this.props.variant || "outlined"}
                value={this.props.email}
                onChange={(e) => this.props.onChange(e.target.value)}
                onBlur={(e) => {
                    let isError = !validateEmail(this.props.email)
                    this.setState({ emailFormatError: isError})
                    if(this.props.onFormatErrorChange)
                        this.props.onFormatErrorChange(isError)
                }}
                style={{ width: '100%' }}
                helperText={this.state.emailFormatError ? WrongEmailFormatText : ''}
                error={this.state.emailFormatError}
                disabled={this.props.disabled}
            />
        );
    }
}

export default EmailInput;